module.exports = __webpack_public_path__ + "img/solo-sms.c68bc36c.png";